import { createSlice } from "@reduxjs/toolkit";
import { decrypt } from "../../../utils/crypto";

const token =
  localStorage.getItem("token") && decrypt(localStorage.getItem("token"));
const superAdminAuth =
  localStorage.getItem("super-admin-auth") &&
  decrypt(localStorage.getItem("super-admin-auth"));

let user = token ? token : superAdminAuth;

if (user?.error) {
  user = {
    authToken: "",
    email: "",
    first_name: "",
    last_name: "",
    profile_pic: "",
  };
}

const authState = {
  googleAuthenticate: false,
  user: user || {},
  logoutLoader: false,
  welcomeScreenLoader: true,
  tableRefresh: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState: authState,
  reducers: {
    loginBegins(state) {
      state.googleAuthenticate = true;
    },
    loginSuccess(state, action) {
      state.googleAuthenticate = false;
      state.user = action.payload;
    },
    loginFailure(state) {
      state.googleAuthenticate = false;
    },
    turnOffWelcomeScreenLoader(state) {
      state.welcomeScreenLoader = false;
    },
    setTriggerTableRefresh(state, action) {
      state.tableRefresh = action.payload;
    },
    logoutSuccess(state) {
      state.user = {};
    },
  },
});

export const {
  loginBegins,
  loginSuccess,
  loginFailure,
  turnOffWelcomeScreenLoader,
  setTriggerTableRefresh,
  logoutSuccess,
} = authSlice.actions;

export default authSlice.reducer;
